/* eslint-disable import/prefer-default-export */
export const USER_TYPE = {
  superadmin: 1, organisationadmin: 2, organisationUser: 3,
};
